import { jsx as _jsx } from "react/jsx-runtime";
import { getMemberTransactions } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { MemberTransactionListTableRow } from './table-row';
const b = bemClassBuilder('v-member-transaction-list-table-body');
export const MemberTransactionListTableBody = observer(() => {
    const transactions = getMemberTransactions();
    const transactionList = transactions || [];
    return (_jsx("tbody", Object.assign({ className: b.block() }, { children: transactionList.map(transaction => (_jsx(MemberTransactionListTableRow, { transaction: transaction }, transaction.id))) })));
});
MemberTransactionListTableBody.displayName = 'MemberTransactionListTableBody';
